module.exports = __webpack_public_path__ + "static/BG Animation-e25f81f3a01a112d5bbd341df5555385.mp4";